import React, { Fragment } from 'react';
import Header from '../../containers/Header';
import PageHeading from '../PageHeading';

const PageNotAllowed = () => {
  return (
    <Fragment>
      <div className="appWrap">
        <div className="MainContentWrap">
          <Header />
          <div className="footerMarginContainer-hr">
            <PageHeading mobileTitle="Sorry, This is page is not allowed!">
              Sorry, This is page is not allowed!
            </PageHeading>
            <div className="exit-booking__content">
              <div className="exit-booking__stripes subhdr-stripes subhdr-stripes--sub subhdr-stripes--ucase hide-phone">
                <span className="stripes-bg" />
              </div>
              <div className="exit-booking__content-wrap">
                <div className="exit-booking__bubble">
                  <div className="bubble">
                    <p className="exit-booking__bubble-text">Oh Shikkatsu!</p>
                  </div>
                  <i className="icon icon--frown-reflection" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PageNotAllowed;
